// extracted by mini-css-extract-plugin
module.exports = {"contactBox":"styles-module--contactBox--ZXN4c"};